import React, { useState } from "react";
import { ButtonBase, colors, Grid, Hidden, Typography } from "@material-ui/core";
import Barcode from "react-barcode/lib/react-barcode";
import { sto } from "../../../../../Context/InshData";
import BarcodeImg from "./BarcodeImg";
import { useTranslation } from "react-i18next";
import "../../../../../Reviews/Invs/AFReadyDisigen/riyals.css"
function BarcodeNewDesign(props) {
    const { t } = useTranslation(["forms"]);
    const { barcode, itemName, price, maqas, permiCuCo, tax, AutoOptions, barcodeOption, data, itemCom } = props;
    let Item_Price = price;

    const textSub = itemCom.map(item => item?.itemName).join("-");

    if (permiCuCo == 0 && tax != 0) {
        Item_Price = (price + (price * tax) / 100).toFixed(2);
    } else {
        Item_Price = price;
    }
    const width = 2.6;
    // const hight = 40;
    const hight = barcodeOption.heightCm * 10;
    const showItem = barcodeOption?.showImg;
    const showLogo = barcodeOption?.showLogo;


    return (
        <div style={{
            width: `${barcodeOption.widthCm}cm`,
            minHeight: `${barcodeOption.heightCm}cm`,
            // minHeight: '20mm',
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "1mm",
            overflow: "hidden",
        }}>

            <BarcodeImg {...{ AutoOptions, showLogo, showItem, data }} />
            {barcodeOption.showFound &&
                <div
                    style={{
                        width: "100%",
                        textAlign: "center",
                        fontWeight: "bold",
                        fontSize: "1rem",
                        direction: "rtl",
                        paddingLeft: "0.1rem",
                        paddingRight: "0.1rem",
                    }}
                >
                    {AutoOptions?.Found[0]?.nameA}
                </div>
            }

            {barcodeOption.showName &&
                <div
                    // style={{
                    //     width: "100%",
                    //     textAlign: "center",
                    //     fontWeight: "bold",
                    //     fontSize: "0.40cm",
                    //     whiteSpace: "nowrap",
                    //     overflow: "hidden",
                    //     textOverflow: "ellipsis"
                    // }}
                    style={{
                        width: "100%",
                        textAlign: "center",
                        fontWeight: "bold",
                        fontSize: "0.7rem",
                        direction: "rtl",
                        paddingLeft: "0.1rem",
                        paddingRight: "0.1rem",
                    }}
                >
                    {itemName}
                </div>
            }

            {barcodeOption.showSub &&
                <div
                    style={{
                        width: "100%",
                        textAlign: "center",
                        fontWeight: "bold",
                        fontSize: "0.40cm",
                        direction: "rtl",
                    }}
                >
                    {t("components")}{": "}{textSub}
                </div>
            }
            <div
                style={{
                    width: '100%',
                    // paddingRight: '1mm',
                    // paddingLeft: '1mm',
                    // padding: '1mm',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    fontSize: '10px',
                    fontWeight: "bold"
                    , backgroundColor: '#fff',

                }}
            >
                <Barcode style={{ fontWeight: "bold" }} value={barcode} displayValue={barcodeOption?.showNumber} format="CODE128" width={1.5} height={hight} margin={0} />

            </div>
            {barcodeOption.showPrice &&
                <div style={{ direction: "rtl", textAlign: "center", fontWeight: "bold", maxLines: 1, fontSize: "1rem", }}>
                    {!barcodeOption?.priceName ? " السعر " : "  السعر شامل الضريبة  "}{Item_Price}{"   "}
                    {barcodeOption.omla}
                    {["RS", "SAR", "SR"].includes(barcodeOption.omla) ?
                        <span style={{ fontFamily: "SaudiRiyal", fontSize: 20, paddingRight:"10px" }}>{"\u20C1"}</span>
                        :barcodeOption.omla
                    }
                </div>
            }
            {barcodeOption.useDate &&
                <Grid
                    container
                    xs={12}
                    style={{ fontSize: "8px", }} >
                    <Grid item xs={6} style={{ direction: "rtl", textAlign: "center", fontWeight: "bold", maxLines: 1, fontSize: "0.35cm" }}>
                        {"PRO   "}{barcodeOption.datePre}
                    </Grid>
                    <Grid item xs={6} style={{ direction: "rtl", textAlign: "center", fontWeight: "bold", maxLines: 1, fontSize: "0.35cm" }}>
                        {"EXP   "} {barcodeOption.dateEx}
                    </Grid>
                </Grid>
            }

        </div>
    );
}

export default BarcodeNewDesign;
